/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyDetailResponse } from '../../models/company-detail-response';
import { CreateCompanyRequest } from '../../models/create-company-request';

export interface PostApiAdministrativeV1Create$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The request payload containing company details.
     */
    body?: CreateCompanyRequest
}

export function postApiAdministrativeV1Create$Plain(http: HttpClient, rootUrl: string, params?: PostApiAdministrativeV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiAdministrativeV1Create$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyDetailResponse>;
    })
  );
}

postApiAdministrativeV1Create$Plain.PATH = '/private/v1/companies/create';
